import React, { Component } from "react";
import SideMenu from "../../SideMenu/SideMenu";
import Header from "../../Header/Header";
import { Link } from "react-router-dom";
import DevicePassword from "./DevicePassword";
import { ButtonGroup, Dropdown, DropdownButton } from "react-bootstrap";
import { errorMessages, actions, deviceMessages } from "../../../helpers/messages";
import ErrorMsgBlockComponent from "../../Error/ErrorMessageBlock";
import { convertUTCToLocalDateTime, getDeviceTypeName } from '../../../helpers/GlobalFunctions';
import SDAFilesContainer from "./SDAFiles";

export default class DeviceDetailsComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showSDABlock: props.showByDefault,
			showPasswordBlock: props.showByDefault,
			showKeysBlock: props.showByDefault,
			showTPMBlock: props.showByDefault,
			showUploadModal: false
		};
	}

	/**
	 * @description Function to toggle show and hide password/key panels
	 * @memberof DeviceDetailsComponent
	 */
	togglePanels = (panelName, event) => {
		event.preventDefault();
		switch (panelName) {
			case 'passwords':
				this.setState(prevState => {
					return {
						showPasswordBlock: !prevState.showPasswordBlock
					}
				})
				break;
			case 'keys':
				this.setState(prevState => {
					return {
						showKeysBlock: !prevState.showKeysBlock
					}
				})
				break;
			case 'tpm':
				this.setState(prevState => {
					return {
						showTPMBlock: !prevState.showTPMBlock
					}
				})
				break;
			/* istanbul ignore next  */
			default:
				break;
		}
	}

	/**
	 * @description Function to return Show More/Less text html
	 * @memberof DeviceDetailsComponent
	 */
	getShowTextTemplate = (panelName, text) => {
		return (
			<div className="showText text-left mt-2">
				<p className="m-0 btn-show-hide d-inline-block fs-8-rem cursor-pointer" data-testid={`${panelName}-panel`} id={`${panelName}-panel`} onClick={(e) => this.togglePanels(panelName, e)}>Show {text}</p>
			</div>
		)
	}

	render() {
		const { fetchTPMCertificateError, tpmCertificateDownloadError, enableTPMCertificate, deviceTPMCertificate, handleCheckSelection, deviceDetails, loading, handleDownload, fetchError, passwordDownloadError, keyDownloadError, 
			disbalePasswordDownloadBtn, disbaleKeyDownloadBtn } = this.props;
		const { showSDABlock, showPasswordBlock, showKeysBlock, showTPMBlock } = this.state;

		return (
			<>
				<div>
					<Header />
					<div className="bgGray" data-testid="deviceDetails">
						<div className="container-fluid">
							<div className="row">
								<div className="col-md-1">
									<SideMenu />
								</div>
								<div className="col-md-11">
									<div className="data-list-tabs review-case-details-wrap">
										<div className="case-details-top-block align-items-center justify-content-between">
											<h1 className="case-details-heading">Device Details</h1>
											<div className="case-details-back-btn text-end gap-2 d-flex justify-content-end">
												<Link className="btn btn-primary case-action-btn" id="view-case" to={"/devices"}>Back to Device List</Link>
											</div>
										</div>

										<div className="mb-4">
											{loading && (
												<div className="loading-overlay-upload add-surgeon-overlay">
													<span>{actions.load}</span>
												</div>
											)}

											{deviceDetails && !loading && (
												<>
													<div className="device-details-container">
														<div className="card-body">
															<div className="row">
																<div className="col-sm-12">
																	<h2 className="card-title pb-2">Details</h2>
																</div>
															</div>
															<div className="row">
																<div className="col-sm-3">
																	<div className="form-group">
																		<label className="col-form-label">Device Serial No.</label>
																		<span className="form-control disabled">{deviceDetails?.details?.serialNo}</span>
																	</div>
																</div>
																<div className="col-sm-3">
																	<div className="form-group">
																		<label className="col-form-label">Source</label>
																		<span className="form-control disabled">{deviceDetails?.details?.location?.toUpperCase() || 'N/A'}</span>
																	</div>
																</div>

																<div className="col-sm-3">
																	<div className="form-group">
																		<label className="col-form-label">Device Type</label>
																		<span className="form-control disabled">{deviceDetails?.details?.deviceType ? getDeviceTypeName(deviceDetails?.details?.deviceType) : 'N/A'}</span>
																	</div>
																</div>

																<div className="col-sm-3">
																	<div className="form-group">
																		<label className="col-form-label">Created On</label>
																		<span className="form-control disabled">{deviceDetails?.details?.createdDate ? convertUTCToLocalDateTime(deviceDetails?.details?.createdDate) : 'N/A'}</span>
																	</div>
																</div>
																<div className="col-sm-3">
																	<div className="form-group">
																		<label className="col-form-label">Date of Manufacture</label>
																		<span className="form-control disabled">{deviceDetails?.details?.Date_of_manufacture?.toUpperCase() || 'N/A'}</span>
																	</div>
																</div>
															</div>
														</div>
													</div>

													{/* SDA Files */}
													<div className={`device-details-container ${showSDABlock ? '' : 'shrink'}`}>
														<div className="card-body">
															<SDAFilesContainer deviceDetails={deviceDetails} />
														</div>
													</div>	

													{/* View Passwords */}
													<div className={`device-details-container ${showPasswordBlock ? '' : 'shrink'}`}>
														<div className="card-body">
															<div className="row">
																<div className="col-8">
																	<h2 className="card-title pb-0">Passwords</h2>
																	{passwordDownloadError && <div className="text-danger">{passwordDownloadError}</div>}
																</div>

																{deviceDetails?.passwords?.length && !disbalePasswordDownloadBtn ? (
																	<div className="col-4 text-end">
																		<DropdownButton as={ButtonGroup} id="password-download-menu" data-testid="password-download-menu" variant="primary" title="Download">
																			<Dropdown.Item
																				eventKey="1"
																				data-testid="PasswordDownloadAll"
																				onClick={() => handleDownload("password", "downloadAll", "all")}
																			>
																				All Passwords
																			</Dropdown.Item>
																			<Dropdown.Item
																				eventKey="2"
																				data-testid="PasswordDownloadSelected"
																				onClick={() => handleDownload("password", "downloadSelected", "selected_keys")}
																				disabled={!deviceDetails?.passwords.filter((x) => x.checked).length}
																			>
																				Selected Passwords
																			</Dropdown.Item>
																		</DropdownButton>
																	</div>
																) : ''}
															</div>

															{deviceDetails.passwords.length ? <>
																{showPasswordBlock ?
																	<div className="row my-2">
																		{deviceDetails.passwords.map((x, i) => {
																			return (
																				<div className="col-3 py-1" key={`view-${i + 1}`}>
																					<DevicePassword
																						label={x.label}
																						id={`${x.htmlID}-view`}
																						isVisible={x.isVisible}
																						value={x.value}
																						type={x.type}
																						checked={x.checked}
																						htmlID={x.htmlID}
																						handleCheckSelection={handleCheckSelection}
																						handleDownload={handleDownload}
																					/>
																				</div>
																			);
																		})}

																		{this.getShowTextTemplate('passwords', 'Less')}
																	</div>
																	: this.getShowTextTemplate('passwords', 'More')}
															</> : <>
																<div className="col-12 text-center text-danger my-4">{deviceMessages.noPermission('passwords')}</div>
															</>}

														</div>
													</div>

													{/* View Keys */}
													<div className={`device-details-container ${showKeysBlock ? '' : 'shrink'}`}>
														<div className="card-body">
															<div className="row">
																<div className="col-6">
																	<h2 className="card-title pb-0">Keys</h2>
																	{keyDownloadError && <div className="text-danger">{keyDownloadError}</div>}
																</div>
																{deviceDetails?.keys?.length && !disbaleKeyDownloadBtn ? (
																	<div className="col-6 text-end">
																		<DropdownButton as={ButtonGroup} id="key-download-menu" data-testid="key-download-menu" variant="primary" title="Download">
																			<Dropdown.Item
																				eventKey="1"
																				data-testid="KeyDownloadAll"
																				onClick={() => handleDownload("key", "downloadAll", "all")}
																			>
																				All Keys
																			</Dropdown.Item>
																			<Dropdown.Item
																				eventKey="2"
																				data-testid="KeyDownloadSelected"
																				onClick={() => handleDownload("key", "downloadSelected", "selected_keys")}
																				disabled={!deviceDetails?.keys.filter((x) => x.checked).length}
																			>
																				Selected Keys
																			</Dropdown.Item>
																		</DropdownButton>
																	</div>
																) : ''}
															</div>

															{deviceDetails.keys.length ? <>
																{showKeysBlock ?
																	<div className="row my-2">
																		{deviceDetails.keys.map((x, i) => {
																			return (
																				<div className="col-3 py-1" key={`view-${i + 1}`}>
																					<DevicePassword
																						label={x.label}
																						id={`${x.htmlID}-view`}
																						isVisible={x.isVisible}
																						value={x.value}
																						type={x.type}
																						checked={x.checked}
																						htmlID={x.htmlID}
																						handleCheckSelection={handleCheckSelection}
																						handleDownload={handleDownload}
																					/>
																				</div>
																			);
																		})}

																		{this.getShowTextTemplate('keys', 'Less')}
																	</div>
																	: this.getShowTextTemplate('keys', 'More')}
															</> : <>
																<div className="col-12 text-center text-danger my-4">{deviceMessages.noPermission('keys')}</div>
															</>}
														</div>
													</div>

													{/* View TPM Certificate */}
													{enableTPMCertificate && !loading && (
														<div className={`device-details-container tpm-certificate ${showTPMBlock ? '' : 'shrink'}`}>
															<div className="card-body">
																<div className="row">
																	<div className="col">
																		<h2 className="card-title pb-0">TPM Certificate</h2>
																		{tpmCertificateDownloadError && <div className="text-danger text-center py-4">{tpmCertificateDownloadError}</div>}
																		{fetchTPMCertificateError && <div className="text-danger text-center py-4">{fetchTPMCertificateError.message || errorMessages.generic}</div>}
																	</div>
																</div>
																{deviceTPMCertificate && deviceTPMCertificate.length ? <>
																	{showTPMBlock ?
																		<div className="row my-2">
																			{deviceTPMCertificate?.map((x, i) => {
																				return (
																					<div className="col-6 py-1" key={`view-${i + 1}`}>
																						<DevicePassword
																							label={x.label}
																							id={`${x.htmlID}-view`}
																							isVisible={x.isVisible}
																							hideCheckbox={true}
																							value={x.value}
																							type={x.type}
																							checked={x.checked}
																							htmlID={x.htmlID}
																							handleCheckSelection={handleCheckSelection}
																							handleDownload={handleDownload}
																						/>
																					</div>
																				);
																			})}

																			{this.getShowTextTemplate('tpm', 'Less')}
																		</div>
																		: this.getShowTextTemplate('tpm', 'More')}
																</> : ''}
															</div>
														</div>
													)
													}
												</>
											)}

											{fetchError && !loading && (
												<div className="device-details-container">
													<div className="card-body">
														<ErrorMsgBlockComponent errorObject={fetchError} />
													</div>
												</div>
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
}
